import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';
import { Item } from '../listbox/listbox.component';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@app/core/services/translate.service';
import { MatDialog } from '@angular/material/dialog';
import { PopupService } from '@app/core/services/popup.service';

@Injectable({
    providedIn: 'root',
})
export class NavBarService {
    private homeButtonVisibleSubject = new BehaviorSubject<boolean>(true);

    public homeButtonVisible$ = this.homeButtonVisibleSubject.asObservable();

    private backButtonVisibleSubject = new BehaviorSubject<boolean>(false);

    public backButtonVisible$ = this.backButtonVisibleSubject.asObservable();

    private headingSubject = new BehaviorSubject<string>('TouchTime');

    public heading$ = this.headingSubject.asObservable();

    private headingVisibleSubject = new BehaviorSubject<boolean>(true);

    public headingVisible$ = this.headingSubject.asObservable();

    constructor(
        private datatask: DataTaskService,
        private translate: TranslateService,
        private dialog: MatDialog,
        private popup: PopupService,
    ) {}

    public async get(): Promise<NavBarGet> {
        return (await this.datatask.Post(2978))[0];
    }

    public async search(query: string): Promise<Item[]> {
        return (await this.datatask.Post(2855, { global_searchtext: query })).map((item: Item) => ({ ...item, item_glyphicon: 'fal ' + item.item_glyphicon }));
    }

    public async setHeading(title: string, translate: boolean = false) {
        console.log('setHeading');
        let parsedTitle = title;

        if (translate) {
            parsedTitle = await this.translate.translate(parsedTitle);
        }

        this.headingSubject.next(parsedTitle);
        console.log('parsedTitle :>> ', parsedTitle);
    }

    public getHeading(): string {
        return this.headingSubject.getValue();
    }

    public setHeadingVisible(visible: boolean) {
        this.headingVisibleSubject.next(visible);
    }

    public setBackButtonVisible(visible: boolean) {
        this.backButtonVisibleSubject.next(visible);
    }

    public setHomeButtonVisible(visible: boolean) {
        this.homeButtonVisibleSubject.next(visible);
    }

    public openVideoTutorialsDialog(argtype: string, argvalue: string) {
        return this.popup.openPopup(`videotutorials/${argtype}/${argvalue}`, { rememberId: `popup.videotutorials` });
    }

    /**
     * Opens a popup with the helpdoc page for the page with the given webpage name.
     * If not webpagename is given, then the webpage name is inferred from the current state.
     *
     * @param webpageName the name of the webpage to go to.
     */
    public openHelpDocDialog(webpageName: string): Promise<{ popup: Window; closed: BehaviorSubject<boolean> } | null> {
        webpageName;

        if (webpageName) {
            return this.popup.openPopup('helpdoc/webpage/' + webpageName, { rememberId: `popup.helpdoc.webpage` });
        }

        throw Error('webpagename required for webpage helpdoc');
    }

    public openFavouritesDialog() {
        //
    }
}

export interface NavBarGet {
    globalsearch_placeholder: string;
    mainmenu_logo: string;
    sidebar_open_mobile: '1' | '0';
    sidebar_open_desktop: '1' | '0';
    notification_interval: number | string;
    user_name: string;
    company_name: string;
}
